/**
 * menu-delay-granel.js
 * Añade un delay de 350ms al cierre del submenú del header.
 * El tema llama a deactivate() inmediatamente en pointerleave —
 * aquí interceptamos el aria-expanded para que no se cierre tan rápido.
 */
(function () {
  const CLOSE_DELAY = 170; // ms — tiempo que tiene el ratón para llegar al dropdown

  function patchHeaderMenu() {
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu) return;

    let closeTimer = null;

    // Interceptar el método deactivate añadiendo delay
    const originalDeactivate = headerMenu.deactivate?.bind(headerMenu);
    if (!originalDeactivate) return;

    headerMenu.deactivate = function (event) {
      // Cancelar cualquier cierre pendiente
      if (closeTimer) clearTimeout(closeTimer);

      // Comprobar si el ratón se mueve hacia el submenú
      const relatedTarget = event?.relatedTarget;
      const activeItem = this._HeaderMenu__state?.activeItem ?? null;
      const submenu = activeItem?.querySelector('[ref="submenu[]"], .menu-list__submenu');

      if (relatedTarget && submenu && submenu.contains(relatedTarget)) {
        // Se mueve al submenú — no cerrar
        return;
      }

      // Delay antes de cerrar
      closeTimer = setTimeout(() => {
        originalDeactivate(event);
        closeTimer = null;
      }, CLOSE_DELAY);
    };

    // También escuchar el submenu — si el ratón entra, cancelar el cierre
    headerMenu.addEventListener('pointerenter', (e) => {
      if (e.target?.closest?.('.menu-list__submenu, .menu-list__submenu-inner')) {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }
    }, { capture: true });
  }

  // Esperar a que el custom element esté definido
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(patchHeaderMenu, 100));
  } else {
    setTimeout(patchHeaderMenu, 100);
  }
})();
